export default __webpack_public_path__ + "static/media/cdec04f4fd65b7d10b71c136ddb716d01580211416315.1fbefda2.webp";